export default __webpack_public_path__ + "static/media/sample-grid-sketcher-dot.9684ded4.svg";